import { isEmpty } from "./isEmpty-B2dexaif.mjs";
import { isNil } from "./isNil-n-HZ9AXW.mjs";

//#region src/isNilOrEmpty.ts
/**
* Returns `true` if the given value is its type's empty value, `null` or `undefined`.
*
* @category Logic
*/
function isNilOrEmpty(val) {
	return isNil(val) || isEmpty(val);
}
var isNilOrEmpty_default = isNilOrEmpty;

//#endregion
export { isNilOrEmpty_default };
//# sourceMappingURL=isNilOrEmpty-Ca3Rotze.mjs.map